// Value Proposition Bar — auto-generated chain from cross-links

import { ArrowRight } from 'lucide-react'
import type { ValuePropChain } from '@ispot/shared'

interface ValuePropBarProps {
  chain: ValuePropChain | null
}

const SLOTS: { key: keyof ValuePropChain; label: string; domain: 'problem' | 'solution' }[] = [
  { key: 'persona', label: 'PERSONA', domain: 'problem' },
  { key: 'need', label: 'NEED', domain: 'problem' },
  { key: 'capability', label: 'CAPABILITY', domain: 'solution' },
  { key: 'feature', label: 'FEATURE', domain: 'solution' },
  { key: 'benefit', label: 'BENEFIT', domain: 'solution' },
]

export function ValuePropBar({ chain }: ValuePropBarProps) {
  if (!chain) return null

  return (
    <div className="border-t border-border bg-warm-100 px-5 py-2.5 flex-shrink-0">
      <div className="text-[10px] font-semibold uppercase tracking-wide text-text-muted mb-1.5">
        Value proposition (auto-generated from links)
      </div>
      <div className="flex items-center gap-1 overflow-x-auto">
        {SLOTS.map((slot, i) => {
          const value = chain[slot.key] as { id: string; title: string } | undefined
          return (
            <div key={slot.key} className="contents">
              {i > 0 && <ArrowRight size={14} className="text-warm-400 flex-shrink-0" />}
              <div className="flex flex-col px-3 py-1.5 rounded-md bg-surface border border-border-subtle flex-shrink-0 max-w-[180px]">
                <span className={`text-[9px] font-semibold uppercase tracking-wide mb-0.5 ${slot.domain === 'problem' ? 'text-market' : 'text-solution-dark'}`}>
                  {slot.label}
                </span>
                <span className="text-[12px] text-text truncate">
                  {value?.title || '—'}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
